import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class SupplierSelectController extends Controller {
  static targets = ["supplierSelect"];

  supplierSelectTargetConnected(el) {
    this.selectedSupplierOption = this.getSelectedOptionFromDom(el);

    this.supplierSelect = new SlimSelect({
      select: el,
      settings: {
        placeholderText: "Escolha...",
        searchText: "Nenhum resultado...",
        searchPlaceholder: "Pesquise...",
        searchingText: "Pesquisando...",
        allowDeselect: false,
        contentLocation: document.body,
      },
      events: {
        search: (search) => this.searchSuppliers(search, el),
        afterChange: (suppliers) => {
          const supplier = Array.isArray(suppliers) ? suppliers[0] : null;
          this.selectedSupplierOption = this.normalizeSelectedOption(supplier);
        },
      },
    });
  }

  supplierSelectTargetDisconnected() {
    if (this.supplierSelectTimeout) {
      clearTimeout(this.supplierSelectTimeout);
      this.supplierSelectTimeout = null;
    }

    if (this.supplierSelect) {
      this.supplierSelect.destroy();
      this.supplierSelect = null;
    }
  }

  async searchSuppliers(search, selectElement) {
    if (this.supplierSelectTimeout) clearTimeout(this.supplierSelectTimeout);

    return await new Promise((resolve) => {
      this.supplierSelectTimeout = setTimeout(async () => {
        const urlString = "/admin/suppliers/slim_select_search";
        const url = new URL(urlString, document.baseURI);
        url.searchParams.append("search", search);

        try {
          const response = await fetch(url);
          const data = await response.json();
          resolve(this.mergeSelectedOption(data, selectElement));
        } catch (error) {
          resolve([]);
        }
      }, 300);
    });
  }

  mergeSelectedOption(data, selectElement) {
    if (!Array.isArray(data)) return data;

    const selectedOption =
      this.getSelectedOptionFromDom(selectElement) ||
      this.selectedSupplierOption;

    if (!selectedOption || selectedOption.value === "") {
      return data;
    }

    const selectedValue = String(selectedOption.value);
    const selectedText = selectedOption.text || "";

    const hasSelectedOption = data.some(
      (option) => String(option.value) === selectedValue,
    );

    if (hasSelectedOption) {
      return data.map((option) => {
        if (String(option.value) !== selectedValue) return option;

        return {
          ...option,
          text: option.text || selectedText,
          selected: true,
        };
      });
    }

    return [{ ...selectedOption, selected: true }, ...data];
  }

  getSelectedOptionFromDom(selectElement) {
    const selectedOption = selectElement?.selectedOptions?.[0];

    if (!selectedOption) return null;

    return {
      value: selectedOption.value,
      text: selectedOption.text,
    };
  }

  normalizeSelectedOption(option) {
    if (!option || option.value === undefined || option.value === null) {
      return null;
    }

    return {
      value: option.value,
      text: option.text || "",
    };
  }
}
